/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Toc_EndInputs */

const en_project_toc_end = /** @type {(inputs: Project_Toc_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our services`)
};

const lv_project_toc_end = /** @type {(inputs: Project_Toc_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mūsu pakalpojumi`)
};

/**
* | output |
* | --- |
* | "Our services" |
*
* @param {Project_Toc_EndInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_toc_end = /** @type {((inputs?: Project_Toc_EndInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Toc_EndInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_toc_end(inputs)
	return en_project_toc_end(inputs)
});